import * as SentryBrowser from '@sentry/browser';
import CONFIG from '../config';

const SENTRY_DSN = CONFIG.sentryDSN;
const dev = process.env.ENV !== 'prod';

const isBrowser = typeof window !== 'undefined';

let sentryBrowserInstance = false;

/*
1. SENTRY BROWSER: INITIALIZATION
2. SENTRY BROWSER: CAPTURE STUFF
*/

/* 1. SENTRY BROWSER: INITIALIZATION */
export function initializeSentryBrowser() {
    if (!sentryBrowserInstance && isBrowser && SentryBrowser) {
        const isProduction = window.location.hostname.includes('noon.com');
        if (isProduction || window.location.hostname.includes('noonstg.com')) {
            SentryBrowser.init({
                dsn: SENTRY_DSN,
                environment: isProduction ? 'production' : 'staging',
            });
            sentryBrowserInstance = true;
        }
    }
}

/* 2. SENTRY BROWSER: CAPTURE STUFF */
export function captureEvent(message: string, extra: any) {
    if (!dev && sentryBrowserInstance) {
        SentryBrowser.captureEvent({ message, extra });
    }
    if (dev) {
        console.error(message, extra); // tslint:disable-line no-console
    }
}



// WEBPACK FOOTER //
// ./src/utils/sentryHelper.js